<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <h5 class="form-header">Nuevo Proveedor</h5>
              <div class="form-desc">
                Adición de un proveedor para compra de productos o servicios
              </div>
              <div class="row">
                <div class="col-sm-3 col-md-2">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }"
                      >Código</label
                    >
                    <input
                      v-model="current.codigo"
                      class="form-control"
                      placeholder="Código"
                      readonly="readonly"
                      type="text"
                      v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }"
                    />
                    <small
                      v-if="current.errors && current.errors.codigo"
                      class="form-text text-danger"
                      >{{ current.errors.codigo[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-9 col-md-10">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.nombre &&
                          current.errors.nombre.length > 0,
                      }"
                      >Nombre</label
                    >
                    <input
                      v-model="current.nombre"
                      class="form-control"
                      placeholder="Nombre"
                      autofocus="autofocus"
                      v-bind:class="{
                        'is-invalid':
                          current.errors.nombre &&
                          current.errors.nombre.length > 0,
                      }"
                      type="text"
                    />
                    <small
                      v-if="current.errors && current.errors.nombre"
                      class="form-text text-danger"
                      >{{ current.errors.nombre[0] }}</small
                    >
                  </div>
                </div>
              </div>

              <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <a
                    class="nav-item nav-link active"
                    id="nav-home-tab"
                    data-toggle="tab"
                    href="#nav-home"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected="true"
                    >Información General</a
                  >
                  <a
                    class="nav-item nav-link"
                    id="direccion-tab"
                    data-toggle="tab"
                    href="#asignados"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >Productos Asignados</a
                  >
                  <a
                    class="nav-item nav-link"
                    id="direccion-tab"
                    data-toggle="tab"
                    href="#direccion"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >Dirección</a
                  >
                  <a
                    class="nav-item nav-link"
                    id="contables-tab"
                    data-toggle="tab"
                    href="#contables"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >Datos Contables</a
                  >
                  <a
                    class="nav-item nav-link"
                    id="finanzas-tab"
                    data-toggle="tab"
                    href="#finanzas"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >Finanzas</a
                  >
                  <a
                    class="nav-item nav-link"
                    id="contactos-tab"
                    data-toggle="tab"
                    href="#contactos"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >Contactos</a
                  >
                </div>
              </nav>
              <div class="tab-content element-box" id="nav-tabContent">
                <div
                  class="tab-pane fade show active"
                  id="nav-home"
                  role="tabpanel"
                  aria-labelledby="nav-home-tab"
                >
                  <div class="row">
                    <div class="col-md-5">
                      <div class="form-group">
                        <label for>Teléfono 1</label>
                        <input
                          v-model="current.telefono1"
                          class="form-control"
                          placeholder="Teléfono 1"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Teléfono 2</label>
                        <input
                          v-model="current.telefono2"
                          class="form-control"
                          placeholder="Teléfono 2"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Teléfono Móvil</label>
                        <input
                          v-model="current.telefono_movil"
                          class="form-control"
                          placeholder="Teléfono Móvil"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>FAX</label>
                        <input
                          v-model="current.fax"
                          class="form-control"
                          placeholder="FAX"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Email</label>
                        <input
                          v-model="current.email"
                          class="form-control"
                          placeholder="Email"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-md-5 offset-md-2">
                      <div class="form-group">
                        <label for>Persona Contacto</label>
                        <input
                          v-model="current.nombre_contacto"
                          class="form-control"
                          placeholder="Persona Contacto"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>NIT</label>
                        <input
                          v-model="current.nit"
                          class="form-control"
                          placeholder="NIT"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>DPI</label>
                        <input
                          v-model="current.dpi"
                          class="form-control"
                          placeholder="DPI"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Web Site</label>
                        <input
                          v-model="current.web_site"
                          class="form-control"
                          placeholder="Web Site"
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            checked
                            class="form-check-input"
                            name="optionsRadios"
                            v-model="current.activo"
                            type="radio"
                            value="true"
                          />Activo
                        </label>
                      </div>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            v-model="current.activo"
                            name="optionsRadios"
                            type="radio"
                            value="false"
                          />Inactivo
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="direccion"
                  role="tabpanel"
                  aria-labelledby="direccion-tab"
                >
                  <div class="row">
                    <div class="col-md-5">
                      <h6>Dirección Comercial</h6>
                      <br />
                      <div class="form-group">
                        <label>Dirección</label>
                        <textarea
                          v-model="current.fiscal_direccion"
                          class="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                      <div class="form-group">
                        <label for>Calle</label>
                        <input
                          v-model="current.fiscal_calle"
                          class="form-control"
                          placeholder="Calle"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Colonia</label>
                        <input
                          v-model="current.fiscal_colonia"
                          class="form-control"
                          placeholder="Colonia"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Ciudad</label>
                        <input
                          v-model="current.fiscal_ciudad"
                          class="form-control"
                          placeholder="Ciudad"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Pais</label>
                        <input
                          v-model="current.fiscal_pais"
                          class="form-control"
                          placeholder="Pais"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Estado</label>
                        <input
                          v-model="current.fiscal_estado"
                          class="form-control"
                          placeholder="Estado"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-md-5 offset-md-1">
                      <h6>Dirección Fiscal</h6>
                      <br />
                      <div class="form-group">
                        <label>Dirección</label>
                        <textarea
                          v-model="current.comercial_direccion"
                          class="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                      <div class="form-group">
                        <label for>Calle</label>
                        <input
                          v-model="current.comercial_calle"
                          class="form-control"
                          placeholder="Calle"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Colonia</label>
                        <input
                          v-model="current.comercial_colonia"
                          class="form-control"
                          placeholder="Colonia"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Ciudad</label>
                        <input
                          v-model="current.comercial_ciudad"
                          class="form-control"
                          placeholder="Ciudad"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Pais</label>
                        <input
                          v-model="current.comercial_pais"
                          class="form-control"
                          placeholder="Pais"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Estado</label>
                        <input
                          v-model="current.comercial_estado"
                          class="form-control"
                          placeholder="Estado"
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="asignados"
                  role="tabpanel"
                  aria-labelledby="direccion-tab"
                >
                  <div class="row">
                    <div class="col-11">
                      <ProductoSelectComponent :current="current" />
                    </div>
                    <div class="col-1">
                      <br />
                      <button
                        class="btn btn-success"
                        @click="asignarProductoProveedor(current)"
                      >
                        Asignar Producto
                      </button>
                    </div>
                    <ProductoProveedorTable
                      :current="current"
                      @refreshProductoProveedor="
                        refreshProductoProveedor(current.id)
                      "
                      :data="data"
                    />
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="contables"
                  role="tabpanel"
                  aria-labelledby="contables-tab"
                >
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors && current.errors.length > 0,
                          }"
                        >
                        </label>
                        <CuentaContableSelectComponent
                          :propname="'cuenta_contable_debe_obj'"
                          :current="current"
                          :label="'Cuenta Contable Debe'"
                        />
                        <small
                          v-if="current.errors"
                          class="form-text text-danger"
                          >{{ current.errors.detail }}</small
                        >
                      </div>
                    </div>

                    <div class="col-sm-12">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors && current.errors.length > 0,
                          }"
                        >
                        </label>
                        <CuentaContableSelectComponent
                          :propname="'cuenta_contable_haber_obj'"
                          :current="current"
                          :label="'Cuenta Contable Haber'"
                        />
                        <small
                          v-if="current.errors"
                          class="form-text text-danger"
                          >{{ current.errors.detail }}</small
                        >
                      </div>
                    </div>

                    <div class="col-sm-12">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors && current.errors.length > 0,
                          }"
                        >
                        </label>
                        <CuentaContableSelectComponent
                          :propname="'cuenta_contable_gasto_obj'"
                          :current="current"
                          :label="'Cuenta Contable Gasto'"
                        />
                        <small
                          v-if="current.errors"
                          class="form-text text-danger"
                          >{{ current.errors.detail }}</small
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="finanzas"
                  role="tabpanel"
                  aria-labelledby="finanzas-tab"
                >
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for>Banco</label>
                        <input
                          v-model="current.banco"
                          class="form-control"
                          placeholder="Banco"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for>Cuenta Bancaria para Depósitos</label>
                        <input
                          v-model="current.cuenta_bancaria"
                          class="form-control"
                          placeholder="Cuenta Bancaria para Depósitos"
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors.fact_umbral_sobrante &&
                              current.errors.fact_umbral_sobrante.length > 0,
                          }"
                          >Umbral Sobrante Factura (multiplicador porcentual) <strong v-if="current.fact_umbral_sobrante && !isNaN(parseFloat(current.fact_umbral_sobrante))">({{ (parseFloat(current.fact_umbral_sobrante) * 100).toFixed(8).replace(/\.?0+$/, '') }}%)</strong></label
                        >
                        <input
                          v-model="current.fact_umbral_sobrante"
                          class="form-control"
                          placeholder="0.000005"
                          type="text"
                          v-bind:class="{
                            'is-invalid':
                              current.errors.fact_umbral_sobrante &&
                              current.errors.fact_umbral_sobrante.length > 0,
                          }"
                        />
                        <small
                          v-if="
                            current.errors && current.errors.fact_umbral_sobrante
                          "
                          class="form-text text-danger"
                          >{{ current.errors.fact_umbral_sobrante[0] }}</small
                        >
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors.fact_umbral_faltante &&
                              current.errors.fact_umbral_faltante.length > 0,
                          }"
                          >Umbral Faltante Factura (multiplicador porcentual) <strong v-if="current.fact_umbral_faltante && !isNaN(parseFloat(current.fact_umbral_faltante))">({{ (parseFloat(current.fact_umbral_faltante) * 100).toFixed(8).replace(/\.?0+$/, '') }}%)</strong></label
                        >
                        <input
                          v-model="current.fact_umbral_faltante"
                          class="form-control"
                          placeholder="-0.000005"
                          type="text"
                          v-bind:class="{
                            'is-invalid':
                              current.errors.fact_umbral_faltante &&
                              current.errors.fact_umbral_faltante.length > 0,
                          }"
                        />
                        <small
                          v-if="
                            current.errors && current.errors.fact_umbral_faltante
                          "
                          class="form-text text-danger"
                          >{{ current.errors.fact_umbral_faltante[0] }}</small
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!-- CONTACTOS -->
                <div
                  class="tab-pane fade"
                  id="contactos"
                  role="tabpanel"
                  aria-labelledby="contactos-tab"
                >
                  <h5 class="form-header">Listado de Contactos</h5>
                  <!-------------------- START - Controles arriba de tabla-------------------->
                  
                  <ContactoProveedorTable
                    :id_proveedor=current.id
                  />
                </div>
              <!-- FIN CONTACTOS -->
              </div>
              <div class="form-buttons-w">
                <button class="btn btn-primary" @click="guardar(current)">
                  Guardar
                </button>
                <router-link
                  class="btn btn-default"
                  :to="{ name: 'cat-proveedores', params: {} }"
                >
                  <i class="fa fa-back"></i>
                  Volver al Listado
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import ProveedorService from "@/services/catalogos/ProveedorService";
import Notifications from "@/notifications/notifications";
import CuentaContableSelectComponent from "@/components/commons/CuentaContableSelectComponent";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import ProductoProveedorTable from "@/components/cat/proveedores/ProductoProveedorTable";
import ContactoProveedorTable from "@/components/cat/proveedores/ContactoProveedorTable";

export default {
  components: {
    CuentaContableSelectComponent,
    ProductoSelectComponent,
    ProductoProveedorTable,
    ContactoProveedorTable,
  },
  data() {
    return {
      data: [],
      current: {
        producto: "",
        errors: {},
      },
      proveedorCargado: false,
    };
  },
  computed: {},


  
  watch: {
    "current.fact_umbral_sobrante": function (val) {
      if (!this.current.errors || Array.isArray(this.current.errors)) {
        this.current.errors = {};
      }
      if (val === undefined || val === null || val === "") {
        this.$set(this.current.errors, "fact_umbral_sobrante", [
          "Este campo es requerido",
        ]);
        return;
      }
      let cleaned = val.toString().replace(/[^0-9.]/g, "");
      let parts = cleaned.split(".");
      if (parts.length > 2) {
        cleaned = parts[0] + "." + parts.slice(1).join("");
        parts = cleaned.split(".");
      }
      // Forzar que empiece con 0.
      if (parts[0].length > 1 || (parts[0].length === 1 && parts[0] !== "0")) {
        cleaned = "0." + (parts[1] || "");
        parts = cleaned.split(".");
      }
      if (parts.length >= 2 && parts[1].length > 8) {
        cleaned = parts[0] + "." + parts[1].substring(0, 8);
      }
      if (cleaned !== val.toString()) {
        this.current.fact_umbral_sobrante = cleaned;
        return;
      }
      const num = parseFloat(cleaned);
      if (isNaN(num)) return;
      if (num === 0 || num > 0.5) {
        this.$set(this.current.errors, "fact_umbral_sobrante", [
          "Debe ser mayor a 0 y menor o igual a 0.5",
        ]);
      } else {
        this.$delete(this.current.errors, "fact_umbral_sobrante");
      }
    },
    "current.fact_umbral_faltante": function (val) {
      if (!this.current.errors || Array.isArray(this.current.errors)) {
        this.current.errors = {};
      }
      if (val === undefined || val === null || val === "") {
        this.$set(this.current.errors, "fact_umbral_faltante", [
          "Este campo es requerido",
        ]);
        return;
      }
      let cleaned = val.toString().replace(/[^0-9.-]/g, "");
      if (cleaned.lastIndexOf("-") > 0) {
        cleaned = "-" + cleaned.replace(/-/g, "");
      }
      let parts = cleaned.split(".");
      if (parts.length > 2) {
        cleaned = parts[0] + "." + parts.slice(1).join("");
        parts = cleaned.split(".");
      }
      // Forzar que la parte entera sea 0 o -0
      let integerPart = parts[0];
      if (
        integerPart !== "0" &&
        integerPart !== "-0" &&
        integerPart !== "-" &&
        integerPart !== ""
      ) {
        cleaned = (integerPart.startsWith("-") ? "-0." : "0.") + (parts[1] || "");
        parts = cleaned.split(".");
      }
      if (parts.length >= 2 && parts[1].length > 8) {
        cleaned = parts[0] + "." + parts[1].substring(0, 8);
      }
      if (cleaned !== val.toString()) {
        this.current.fact_umbral_faltante = cleaned;
        return;
      }
      const num = parseFloat(cleaned);
      if (isNaN(num)) return;
      if (num > 0) {
        this.current.fact_umbral_faltante = (num * -1).toString();
        return;
      }
      if (num === 0 || num < -0.5) {
        this.$set(this.current.errors, "fact_umbral_faltante", [
          "Debe ser menor a 0 y mayor o igual a -0.5",
        ]);
      } else {
        this.$delete(this.current.errors, "fact_umbral_faltante");
      }
    },
  },



  mounted() {
    if (this.$route.params.id) {
      ProveedorService.getById(this.$route.params.id).then((response) => {
        this.current = response.data;
        this.current.errors = {};
        this.proveedorCargado = true;
        this.refreshProductoProveedor(this.$route.params.id);
      });
    }
  },

  methods: {
    refreshProductoProveedor(proveedor_id) {
      let self = this;

      DynamicService.fetch("cat", "producto-proveedor", {
        proveedor: proveedor_id,
        quitar_paginacion: true,
      }).then((response) => {
        self.data = response.data;
      });
    },
    asignarProductoProveedor(current) {
      let self = this;
      if (!current.producto) {
        alert("Error, Producto no puede ser Nulo");
        return;
      }
      var parametros = {
        proveedor: current.id,
        producto: current.producto.sku,
      };
      DynamicService.save("cat", "producto-proveedor", parametros)
        .then((response) => {
          Notifications.alert.success(
            "Asignar Producto a Proveedor",
            "Realizado Correctamente"
          );
          current.producto = "";
          self.refreshProductoProveedor(this.$route.params.id);
        })
        .catch((errors) => {
          Notifications.alert.error("Error", response.data.detail);
        });
    },
    DeleteProductoProveedor(producto_id) {
      let self = this;
      var parametros = {
        proveedor: this.current.id,
        producto: producto_id.sku,
      };
      DynamicService.delete("cat", "producto-proveedor", parametros)
        .then((response) => {
          Notifications.alert.success("Eliminado Correctamente");
          self.refreshProductoProveedor(this.$route.params.id);
        })
        .catch((errors) => {
          Notifications.alert.error("Error", response.data.detail);
        });
    },
      guardar(current) {
      let self = this;
      this.current.errors = {};
      let hasErrors = false;

      // Sobrante: (0, 0.5], max 2 decimals
      const sobrante = this.current.fact_umbral_sobrante;
      if (sobrante !== undefined && sobrante !== null && sobrante !== "") {
        const val = parseFloat(sobrante);
        if (val <= 0 || val > 0.5) {
          this.current.errors.fact_umbral_sobrante = [
            "Debe ser mayor a 0 y menor o igual a 0.5",
          ];
          hasErrors = true;
        } else {
          const s = sobrante.toString();
          if (s.includes(".") && s.split(".")[1].length > 8) {
            this.current.errors.fact_umbral_sobrante = ["Máximo 8 decimales"];
            hasErrors = true;
          }
        }
      } else {
        this.current.errors.fact_umbral_sobrante = ["Este campo es requerido"];
        hasErrors = true;
      }

      // Faltante: [-0.5, 0), max 2 decimals
      const faltante = this.current.fact_umbral_faltante;
      if (faltante !== undefined && faltante !== null && faltante !== "") {
        const val = parseFloat(faltante);
        if (val >= 0 || val < -0.5) {
          this.current.errors.fact_umbral_faltante = [
            "Debe ser menor a 0 y mayor o igual a -0.5",
          ];
          hasErrors = true;
        } else {
          const s = faltante.toString();
          if (s.includes(".") && s.split(".")[1].length > 8) {
            this.current.errors.fact_umbral_faltante = ["Máximo 8 decimales"];
            hasErrors = true;
          }
        }
      } else {
        this.current.errors.fact_umbral_faltante = ["Este campo es requerido"];
        hasErrors = true;
      }

      if (hasErrors) {
        Notifications.alert.error(
          "Error de validación",
          "Revise los campos marcados"
        );
        return;
      }

      var current = Object.assign({}, this.current);
      delete current.image;
      if (current.codigo == null) {
        delete current.codigo;
      }
      let value = current.cuenta_contable_debe_obj;
      if (value && typeof value === "object" && value.constructor === Object) {
        current.cuenta_contable_debe = current.cuenta_contable_debe_obj.id;
      }
      value = current.cuenta_contable_haber_obj;
      if (value && typeof value === "object" && value.constructor === Object) {
        current.cuenta_contable_haber = current.cuenta_contable_haber_obj.id;
      }
      value = current.cuenta_contable_gasto_obj;
      if (value && typeof value === "object" && value.constructor === Object) {
        current.cuenta_contable_gasto = current.cuenta_contable_gasto_obj.id;
      }
      ProveedorService.save(current)
        .then((res) => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success(
            "Proveedor",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cat-proveedores-editar",
            params: { id: self.current.codigo },
          });
        })
        .catch((error) => {
          if (error.response) {
            self.current.errors = error.response.data;
          }
        });
    },
    showModal(e) {
      e.preventDefault();
    },
  },
};
</script>
